import { apiClient } from './client';
import type { ApiSuccess, PaginationMeta } from '../types';

export interface AmRent {
  id: number;
  stationId: number;
  stationName: string | null;
  city: string | null;
  ownerName: string | null;
  ownerPhone: string | null;
  clientId: number | null;
  clientName: string | null;
  monthYear: string;
  amount: number;
  dueDate: string;
  paidDate: string | null;
  paymentMode: string | null;
  transactionRef: string | null;
  status: 'pending' | 'paid' | 'overdue';
  receiptUrl: string | null;
  notes: string | null;
  createdAt: string;
}

export interface CreateRentInput {
  stationId: number;
  clientId?: number | null;
  monthYear: string;
  amount: number;
  dueDate: string;
  notes?: string;
}

export interface PayRentInput {
  paymentMode: 'NEFT' | 'RTGS' | 'UPI' | 'Cheque' | 'Cash';
  transactionRef?: string;
  paidDate?: string;
  receiptUrl?: string;
}

export const amRentApi = {
  async list(params: Record<string, unknown> = {}): Promise<{ data: AmRent[]; meta: PaginationMeta }> {
    const { data } = await apiClient.get<ApiSuccess<AmRent[]>>('/am-rent', { params });
    return { data: data.data, meta: data.meta as PaginationMeta };
  },
  create: async (body: CreateRentInput) => (await apiClient.post<ApiSuccess<AmRent>>('/am-rent', body)).data.data,
  update: async (id: number, body: Partial<CreateRentInput>) => (await apiClient.put<ApiSuccess<AmRent>>(`/am-rent/${id}`, body)).data.data,
  pay: async (id: number, body: PayRentInput) => (await apiClient.post<ApiSuccess<AmRent>>(`/am-rent/${id}/pay`, body)).data.data,
  remove: async (id: number) => { await apiClient.delete(`/am-rent/${id}`); },
};
